export default "__VITE_ASSET__CHsFco3h__"